<template>
	<div>
		<b-card>
			<b-card-text>
				<b-row id="tabel-dinamis-choosen-dataset-title">
					<b-col>
						<h4>{{ datasetTitle }}</h4>
					</b-col>
				</b-row>

				<b-row class="mb-3 text-right">
					<b-col>
						<visualization-table-menu-bar
							:isFinishProcessChoosenData="isFinishProcessChoosenData"
							:choosenData="choosenData"
							:datasetTitle="datasetTitle"
							:accessTime="accessTime"
							:isFreeze.sync="isFreeze"
							:isStripped.sync="isStripped"
							:isHighlighted.sync="isHighlighted"
							:showMetadata.sync="showMetadata"
							:choosenRowFields="rowFields"
							:choosenColumnFields="columnFields"
							:choosenDimensions="dimensions"
							:updateIsNeedReloaded="updateIsNeedReloaded"
							:fontSize.sync="fontSize"
							:tableTheme.sync="tableTheme"
							:updateChoosenRowFields="updateRowFields"
							:updateChoosenColumnFields="updateColumnFields"
							:doSum.sync="doSum"
							:doAverage.sync="doAverage"
							:doMinimum.sync="doMinimum"
							:doMaximum.sync="doMaximum"
							:doMedian.sync="doMedian"
							:doCount.sync="doCount"
							:doStandardDeviation.sync="doStandardDeviation"
							:doMinimumX.sync="doMinimumX"
							:doMaximumX.sync="doMaximumX"
							:doMinimumY.sync="doMinimumY"
							:doMaximumY.sync="doMaximumY"
							:selectedDataList="selectedDataList"
							:choosenDataIdx="choosenDataIdx"
						/>
					</b-col>
				</b-row>

				<b-row v-show="isFinishProcessChoosenData === false">
					<b-col>
						<b-skeleton-table
							:rows="7"
							:columns="4"
							:table-props="{
								bordered: true,
								striped: true,
								'table-class': 'td-skeleton-table',
							}"
						></b-skeleton-table>
					</b-col>
				</b-row>

				<b-row
					id="tabel-dinamis-choosen-dataset-pivot-table"
					v-show="isFinishProcessChoosenData === true"
				>
					<b-col>
						<visualization-pivot-table
							:choosenData="choosenData"
							:choosenDataIdx="choosenDataIdx"
							:choosenRowFields="rowFields"
							:choosenColumnFields="columnFields"
							:choosenDimensions="dimensions"
							:isFinishProcessChoosenData="isFinishProcessChoosenData"
							:updateIsFinishProcessChoosenData="
								updateIsFinishProcessChoosenData
							"
							:tabelDinamisSelectedDataListAlreadyCollapsed="
								tabelDinamisSelectedDataListAlreadyCollapsed
							"
							:isFreeze="isFreeze"
							:isStripped="isStripped"
							:isHighlighted="isHighlighted"
							:isNeedReloaded="isNeedReloaded"
							:updateIsNeedReloaded="updateIsNeedReloaded"
							:fontSize="fontSize"
							:tableTheme="tableTheme"
							:doSum="doSum"
							:doAverage="doAverage"
							:doMinimum="doMinimum"
							:doMaximum="doMaximum"
							:doMedian="doMedian"
							:doCount="doCount"
							:doStandardDeviation="doStandardDeviation"
							:doMinimumX="doMinimumX"
							:doMaximumX="doMaximumX"
							:doMinimumY="doMinimumY"
							:doMaximumY="doMaximumY"
						/>
					</b-col>
				</b-row>

				<b-row id="tabel-dinamis-choosen-dataset-info" class="text-left">
					<b-col>
						<span class="font-weight-bold">Waktu Pengaksesan</span>:
						{{ accessTime }}
					</b-col>
				</b-row>

				<visualization-table-metadata
					:selectedDataList="selectedDataList"
					:choosenDataIdx="choosenDataIdx"
					v-show="showMetadata"
				/>

				<b-row v-if="isFinishProcessChoosenData === true">
					<b-col>
						<div
							id="tabel-dinamis-html-pdf-container"
							style="display: block"
						></div>
						<div
							id="tabel-dinamis-html-pdf-container2"
							style="display: block"
						></div>
					</b-col>
				</b-row>
			</b-card-text>
		</b-card>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import VisualizationPivotTable from "../VisualizationMainContainer/VisualizationTableContainer/VisualizationPivotTable.vue";
import VisualizationTableMenuBar from "../VisualizationMainContainer/VisualizationTableContainer/VisualizationTableMenuBar.vue";
import VisualizationTableMetadata from "../VisualizationMainContainer/VisualizationTableContainer/VisualizationTableMetadata.vue";
import store from "../../../../../../store/TabelDinamisStoreV3.js";
import utils from "../../../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
	name: "VisualizationTableContainer",
	data() {
		return {
			triggerUpdateAccessTime: 0,
			isFreeze: false,
			isStripped: false,
			isHighlighted: false,
			isNeedReloaded: false,
			showMetadata: false,
			fontSize: "m",
			tableTheme: "blue",
			rowFields: [],
			columnFields: [],
			dimensions: {},

			doSum: false,
			doAverage: false,
			doMinimum: false,
			doMaximum: false,
			doMedian: false,
			doCount: false,
			doStandardDeviation: false,

			doMinimumX: false,
			doMinimumY: false,
			doMaximumX: false,
			doMaximumY: false,
		};
	},
	props: [
		"choosenDataIdx",
		"choosenData",
		"choosenRowFields",
		"choosenColumnFields",
		"choosenDimensions",
		"updateIsFinishProcessChoosenData",
		"isFinishProcessChoosenData",
		"tabelDinamisSelectedDataListAlreadyCollapsed",
		"selectedDataList",
		"isProcessingNow",
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		datasetTitle() {
			if (this.choosenDataIdx != null) {
				if (this.isProcessingNow) {
					return this.selectedDataList[0].selectedDataset.name;
				} else {
					return store.getSelectedDataListLocalStorageByCurrentUsername()[0]
						.items[this.choosenDataIdx].selectedDataset.name;
				}
			} else return "";
		},
		accessTime() {
			//this.triggerUpdateAccessTime;

			return (
				new Date().toLocaleString("id-ID", { weekday: "long" }) +
				", " +
				new Date().toLocaleString("en-GB", {
					day: "2-digit",
					month: "long",
					year: "numeric",
				}) +
				" " +
				new Date().toLocaleString("en-GB", {
					hour12: false,
					hour: "2-digit",
					minute: "2-digit",
					second: "2-digit",
				}) +
				" WIB"
			);
		},
	},
	watch: {
		choosenDataIdx: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal && newVal != null) {
					this.triggerUpdateAccessTime++;
					this.isFreeze = false;
					this.isHighlighted = false;
					this.isStripped = false;
					this.showMetadata = false;
					this.fontSize = "m";
					this.tableTheme = "blue";

					this.rowFields = this.choosenRowFields;
					this.columnFields = this.choosenColumnFields;
					this.dimensions = this.choosenDimensions;

					this.doSum = false;
					this.doAverage = false;
					this.doMinimum = false;
					this.doMaximum = false;
					this.doMedian = false;
					this.doCount = false;
					this.doStandardDeviation = false;
				}
			},
		},
		showMetadata: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					if (newVal === true) {
						setTimeout(
							function () {
								utils.scrollIntoDiv(
									"tabel-dinamis-visualization-table-metadata"
								);
							}.bind(),
							500
						);
					}
				}
			},
		},
	},
	methods: {
		updateIsNeedReloaded(val) {
			this.isNeedReloaded = val;
		},
		updateRowFields(val) {
			this.rowFields = val;
		},
		updateColumnFields(val) {
			this.columnFields = val;
		},
	},
	components: {
		"visualization-pivot-table": VisualizationPivotTable,
		"visualization-table-menu-bar": VisualizationTableMenuBar,
		"visualization-table-metadata": VisualizationTableMetadata,
	},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 21-09-2022 -->
